
import { Component, Prop, Vue } from 'nuxt-property-decorator'

@Component
export default class BaseIcon extends Vue {
  @Prop({ required: true }) readonly icon!: string
}
